import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-page',
  templateUrl: './help-page.component.html'
})
export class HelpPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/help/help-page/help-page.component.ts